export const TILE = 64;
export const MAP_COLS = 12;
export const MAP_ROWS = 10;
export const WORLD_W = MAP_COLS * TILE; // 768
export const WORLD_H = MAP_ROWS * TILE; // 640

export const PLAYER_SIZE = 40;
export const PLAYER_SPEED = 160; // px/s
export const CHOP_RANGE = 60;
export const CHOP_HITS = 3;
export const TREE_REGROW_TIME = 20; // seconds
export const TREE_SHAKE_TIME = 0.2;

export const SPEAR_SPEED = 300;
export const SPEAR_LIFETIME = 1.5;
export const THROW_COOLDOWN = 0.5;

export const INTRUDER_SPEED = 45;
export const INTRUDER_SPAWN_INTERVAL = 25; // seconds base
export const INTRUDER_COIN_DROP = 3;
export const INTRUDER_SIZE = 36;

export const VENDOR_RANGE = 70;
export const UPGRADE_RANGE = 70;

export const AUTO_SAVE_INTERVAL = 30; // seconds
export const PARTICLE_POOL_SIZE = 200;

export const WOOD_PER_TREE = 2;
export const WOOD_SELL_PRICE = 2; // coins per wood

// Colors
export const COL_GRASS = '#4a8c2a';
export const COL_GRASS_ALT = '#3f7a24';
export const COL_PATH = '#c4a96a';
export const COL_PATH_ALT = '#b89d5e';

export const COL_ROBOT_BODY = '#4a90d9';
export const COL_ROBOT_HEAD = '#6ab0f0';
export const COL_ROBOT_EYE = '#ffffff';
export const COL_ROBOT_PUPIL = '#1a1a2e';
export const COL_ROBOT_ANTENNA = '#ff6b6b';

export const COL_TREE_TRUNK = '#8b5a2b';
export const COL_TREE_CANOPY = '#2d8a4e';
export const COL_TREE_STUMP = '#6b4226';

export const COL_SLIME = '#9b59b6';
export const COL_SLIME_EYE = '#ffffff';
export const COL_WINDUP_BODY = '#e67e22';
export const COL_WINDUP_KEY = '#95a5a6';

export const COL_VENDOR = '#f1c40f';
export const COL_VENDOR_BODY = '#d4a017';

export const COL_WALL = '#7f8c8d';
export const COL_HOUSE = '#c0392b';
export const COL_HOUSE_ROOF = '#922b21';
export const COL_STATION = '#8e6d47';

export const COL_WOOD_PARTICLE = '#c49a6c';
export const COL_COIN_PARTICLE = '#ffd700';
export const COL_SPARKLE = '#fff176';
export const COL_BOOP_SPARKLE = '#e1bee7';
